<!-- @veltra/icons generated sha256:26fbc60c392e90d3 gen:8 source:src/svg/normal/form-password-input.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormPasswordInput' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="14"
      height="8"
      x="1"
      y="4"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="1.5"
    />
    <circle cx="5" cy="8" r="1" fill="currentColor" />
    <circle cx="8" cy="8" r="1" fill="currentColor" />
    <circle cx="11" cy="8" r="1" fill="currentColor" />
  </svg>
</template>
